export enum Breakpoints {
  MinLargeMonitorWidth = 1920,
  MaxLaptopWidth = 1440,
  MinLaptopWidth = 1240,
  MaxTabletWidth = 1024,
  MinTabletWidth = 768,
  MaxMobileWidth = 510,
  MinMobileWidth = 360
}
